import { action } from 'app/actions';

export const GET_TEACHERS = 'profiles/GET_TEACHERS';
export const getTeachers = payload => action(GET_TEACHERS, { payload });

export const CHANGE_TEACHER_EDIT = 'profiles/CHANGE_TEACHER_EDIT';
export const changeTeacherEdit = payload => action(CHANGE_TEACHER_EDIT, { payload });

export const REMOVE_TEACHER = 'profiles/REMOVE_TEACHER';
export const removeTeacher = payload => action(REMOVE_TEACHER, { payload });
